export default "__VITE_ASSET__C1giYz$d__"